import Vue from 'vue';
import VueRouter from 'vue-router';
import {
  isEmpty
} from 'lodash';
import store from '@/store'
import AdminOrder from '../views/adminOrder/AdminOrder.vue';

Vue.use(VueRouter);

const routes = [{
    path: '/',
    name: 'Store',
    component: () => import('../views/store/Store.vue'),
    children: [{
        path: '/',
        name: 'Main',
        component: () => import('../views/main/Main.vue'),
      },
      {
        path: 'search',
        name: 'Search',
        component: () => import('../views/search/Search.vue'),
      },
    ]
  },
  {
    path: '/adminorder',
    name: 'AdminOrder',
    component: AdminOrder,
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('../views/dashboard/Dashboard.vue'),
    children: [{
        path: '/',
        name: 'DashDef',
        component: () => import('../views/account/Account.vue'),
      },
      {
        path: 'account',
        name: 'Account',
        component: () => import('../views/account/Account.vue'),
      },
    ]
  },
  {
    path: '/payment',
    name: 'Payment',
    component: () => import('../views/payment/Payment.vue'),
    children: [{
        path: '/',
        name: 'PaymentDefault',
        component: () => import('../views/signIn/SignIn.vue'),
      }, {
        path: 'signin',
        name: 'SignIn',
        component: () => import('../views/signIn/SignIn.vue'),
      },
      {
        path: 'signup',
        name: 'SignUp',
        component: () => import('../views/signUp/SignUp.vue'),
      },
      {
        path: 'reset-password',
        name: 'ResetPassword',
        component: () => import('../views/resetPassword/ResetPassword.vue'),
      },
      {
        path: 'change-password',
        name: 'ChangePassword',
        component: () => import('../views/changePassword/ChangePassword.vue'),
      },
      {
        path: 'shipping',
        name: 'Shipping',
        component: () => import('../views/shippingMethod/ShippingMethod.vue'),
      },
      {
        path: 'schedule',
        name: 'Schedule',
        component: () => import('../views/schedule/Schedule.vue'),
      },
      {
        path: 'summary',
        name: 'Summary',
        component: () => import('../views/summary/Summary.vue'),
      },
      {
        path: 'order-finished',
        name: 'OrderFinished',
        component: () => import('../views/orderFinished/OrderFinished.vue'),
      },
      {
        path: 'orders/:orderId',
        name: 'Order',
        component: () => import('../views/order/Order.vue'),
      },

    ]
  },

  {
    path: '*',
    redirect: '/'
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0, behavior: 'instant'}
  },
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/', '/adminorder', '/login', '/search', '/signin', '/payment/signin', '/payment/signup', '/payment/summary','/payment/orders',
    '/payment/shipping', '/payment/schedule', '/payment/reset-password', '/payment/change-password','/payment/order-finished'
  ];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = !isEmpty(store.state.user);
  if (authRequired && !loggedIn) {
    return next('/login');
  }

  store.commit('setPrevRoute', from.path);
  return next();
});

export default router;
